export default __webpack_public_path__ + "static/media/car.3ed2889f.PNG";